import { socket } from "../index";

const emitGetProjectTypes = () => {
  socket?.emit('GET_PROJECT_TYPES', {});
}

export default emitGetProjectTypes;